import { merge } from 'lodash';
import Card from './Card';
import Paper from './Paper';
import Slider from './Slider';
import Typography from './Typography';

export default function ComponentsOverrides(theme) {
  return merge(
    Card(theme),
    Paper(theme),
    Slider(theme),
    Typography(theme),
  );
}
